import { render, staticRenderFns } from "./ApprDtlQry.vue?vue&type=template&id=1ecdadb8"
import script from "./ApprDtlQry.vue?vue&type=script&lang=js"
export * from "./ApprDtlQry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports